module.exports = __webpack_public_path__ + "10dc95cec35d3a18212048788b870256.png";